<template>
	<div class="list-page">
		<el-tabs v-model="status" @tab-click="init">
			<el-tab-pane :label="$t('当前持仓')" name="1"></el-tab-pane>
			<el-tab-pane :label="$t('当前委托')" name="2"></el-tab-pane>
			<el-tab-pane :label="$t('历史委托')" name="3"></el-tab-pane>
			<el-tab-pane :label="$t('历史成交')" name="4"></el-tab-pane>
		</el-tabs>

		<div class="table-div">
			<template v-if="status == 1 || status == 4">
				<div class="th-div dis-fle ali-cen">
					<span class="txt-ali-lef">{{ $t('产品') }}</span>
					<span>{{ $t('方向') }}</span>
					<span>{{ $t('开仓时间') }}</span>
					<span>{{ $t('数量') }}</span>
					<span>{{ $t('收益(USDT)') }}</span>
					<span>{{ $t('保证金率') }}</span>
					<span>{{ $t('初始保证金') }}</span>
					<span>{{ $t('买入价格') }}</span>
					<span v-if="status == 1">{{ $t('操作') }}</span>
				</div>
				<div class="tr-div dis-fle ali-cen" v-for="value in list" :key="value.id">
					<span class="txt-ali-lef">{{ value.product_title }}</span>
					<span :class="value.direction == 1 ? 'green' : 'red'">
						{{ value.direction_text ? value.direction_text : value.direction == 1 ? $t('买入') : $t('卖出') }}
					</span>
					<span>{{ value.opentime_text }}</span>
					<span>{{ value.number }}</span>
					<span>{{ value.fast_profits }}</span>
					<span>{{ value.fee }}</span>
					<span>{{ value.margin_rate }}%</span>
					<span>{{ value.margin_amount }}</span>
					<span>{{ value.limit_price }}</span>
					<span v-if="status == 1">
						<el-button type="primary" size="mini" @click="closePositions(value)">{{ $t('市价全平')
							}}</el-button>
					</span>
				</div>
			</template>

			<template v-else>
				<div class="th-div dis-fle ali-cen">
					<span class="txt-ali-lef">{{ $t('产品') }}</span>
					<span>{{ $t('方向') }}</span>
					<span>{{ $t('委托时间') }}</span>
					<span>{{ $t('委托总数量') }}</span>
					<span>{{ $t('委托价格') }}</span>
					<span>{{ $t('成交价格') }}</span>
					<span>{{ $t('已完成量') }}</span>
					<span>{{ $t('类型') }}</span>
					<span>{{ $t('状态') }}</span>
					<span v-if="status == 2">{{ $t('操作') }}</span>
				</div>
				<div class="tr-div dis-fle ali-cen" v-for="value in list" :key="value.id">
					<span class="txt-ali-lef">{{ value.product_title }}</span>
					<span :class="value.direction == 1 ? 'green' : 'red'">
						{{ value.direction_text ? value.direction_text : value.direction == 1 ? $t('买入') : $t('卖出') }}
					</span>
					<span>{{ value.createtime_text }}</span>
					<span>{{ value.number }}</span>
					<span>{{ value.limit_price }}</span>
					<span>{{ value.open_price }}</span>
					<span>{{ value.complete_number }}</span>
					<span>{{ value.type_text }}</span>
					<span>{{ value.status_text }}</span>
					<span v-if="status == 2">
						<el-button type="primary" size="mini" @click="cancelOrder(value)">{{ $t('撤单') }}</el-button>
					</span>
				</div>
			</template>

			<div class="dasda" v-if="list.length <= 0">{{ $t('没有更多数据了') }}</div>
		</div>

		<oPage v-if="page.total > page.limit" :current-page.sync="page.page" :page-size.sync="page.limit"
			class="padd-20" :total="page.total" @current-change="getdata" />
	</div>
</template>

<script>

import { get, post } from '@/http/request'
import apis from '@/http/api'
import oPage from '@/common/pc/oPage.vue'
export default {
	components: {
		oPage,
	},
	props: {
		id: {
			type: [String, Number],
			default: ''
		},
	},
	data() {
		return {
			url: apis.contractOrderList,
			status: '1', // 状态:1=当前持仓,2=当前委托,3=历史委托,4=历史成交

			list: [],
			page: {
				page: 1,
				limit: 10,
				total: 10,
			},
		};
	},
	watch: {
		id() {
			this.init()
		}
	},
	created() {
	},
	methods: {

		init() {
			this.page.page = 1
			this.getdata()
		},
		getdata(showLoading = true) {
			get(this.url, {
				showLoading,
				...this.page,
				status: this.status,
				label: this.status,
				product_id: this.id
			}).then(res => {
				if (res.code != 1) return
				if (Array.isArray(res.data)) {
					this.list = res.data
					this.page.total = 0
					return
				}
				this.list = res.data.list || res.data.data
				this.page.total = res.data.total
			})
		},

		//平仓
		async closePositions(item) {
			const res = await post(apis.closePositions, {
				order_id: item.id,
			})
			if (res.code != 1) return
			this.$notify.success(res.msg);
			this.init()
			this.change()
		},
		//撤单
		async cancelOrder(item) {
			const res = await post(apis.cancelContractOrder, {
				order_id: item.id,
			})
			if (res.code != 1) return
			this.$notify.success(res.msg);
			this.init()
			this.change()
		},

		change() {
			this.$emit('modify')
		},
	},
}
</script>
<style lang="scss" scoped>
.list-page {
	padding: 10px 20px;

	.table-div {
		font-size: 16px;
		line-height: 40px;
		color: #999;
		text-align: center;

		.th-div {
			border-bottom: 1px solid #2b3139;
			padding-bottom: 8px;
		}

		span {
			flex: 1;
		}

		.dasda {
			text-align: center;
			margin: 50px auto;
			color: #888;
		}

	}

	.green {
		color: #00f0ff !important;
	}

	.red {
		color: #ff4834 !important;
	}
}
</style>